import { render, staticRenderFns } from "./VideoGoodsAnalysisModule.vue?vue&type=template&id=33f2ea1f&scoped=true"
import script from "./VideoGoodsAnalysisModule.vue?vue&type=script&lang=js"
export * from "./VideoGoodsAnalysisModule.vue?vue&type=script&lang=js"
import style0 from "./VideoGoodsAnalysisModule.vue?vue&type=style&index=0&id=33f2ea1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2ea1f",
  null
  
)

export default component.exports